module.exports = __webpack_public_path__ + "media/site_templates/www.localhandyman.net.au/images/feature_1-354da342cce2ea4733d29a845060b013.jpeg";